<template>
  <transition name="fade">
    <router-link-modified v-if="isLogged && typeof bookmarksCount === 'number'"
                          :to="{name: 'account-my-vacancies', query: {currentTab: 2}}"
                          style="margin-right: 2rem"
                          class="main-header__bar-btn">
      <BaseSvg name="ico-heart-outline"
               width="1.7rem"
               height="1.5rem"
               style="stroke: none; fill: white"
               class="_stroke  buzz-out"/>
      <span class="main-header__bar-btn-note  _blue">{{ bookmarksCount }}</span>
    </router-link-modified>
    <router-link-modified v-else-if="typeof bookmarksCount === 'number'"
                          :to="{name: 'account-my-vacancies', query: {currentTab: 2, 'for-bookmarks-page': 'true'}}"
                          style="margin-right: 2rem"
                          class="main-header__bar-btn">
      <BaseSvg name="ico-heart-outline"
               width="1.7rem"
               height="1.8rem"
               style="stroke: none; fill: white"
               class="_stroke"/>
      <span class="main-header__bar-btn-note  _blue">{{ bookmarksCount }}</span>
    </router-link-modified>
  </transition>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'HeaderUserPanelBookmarks',
    data() {
      return {}
    },
    computed: {
      ...mapGetters('user', [
        'isLogged',
        'bookmarksCount',
      ]),
    }
  }
</script>

<style lang="less">

</style>
